<template>
    <project-step-container
            cover-page
            prev-to="js_go_broad_to_go_narrow_13"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="first-form-initial first-form-initial-3 pb-2">
            <JAVideo class-name-play="play-video-initial"
                :poster="{src: srcPoster, title:'Rapid Experiments with Customers Video'}"
                title="Rapid Experiments with Customers"
                :sources="videoSources"/>

            <b-col v-on:click="isText = !isText">
                <div v-show="isText" tabindex="0">
                    <b-col cols="8" class="mt-4 main-title-initial cover-body-title-3 text-uppercase" tabindex="0">Rapid Experiments With Customer</b-col>
                    <b-col cols="12" class="mt-2 mb-1 sub-title-initial-3" tabindex="0">
                        {{getMessage(14, 'rapidexperiment-sub')}}
                    </b-col>
                    <p class="text-center" > <span class="step"></span> <span class="step-text"></span>  </p>

               </div>
                <div v-show="!isText">
                    <b-col  cols="12" class="mt-4 mb-1 sub-title-initial-3" tabindex="0">
                       {{getMessage(14, 'rapidexperiment-sub-text')}}
                    </b-col>
                    <p class="text-center" ><span class="step-text"></span> <span class="step"></span> </p>
                </div>
            </b-col>
        </b-row>
        <b-row class="cover-gradient"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import JAVideo from "../../../core/Components/JAVideo"
    import {Steps} from "@/modules/JobShadow/Utils";
    import {ConflictSyn, Project} from "@/core/Utils";

    export default {
        name: "RapidExperimentsWithCustomers14",
        components: {ProjectStepContainer , JAVideo},
        data() {
            return {
                step:Steps.FORM_JS_RAPID_EXPERIMENTS,
                isText: true
            }
        },
        computed: {
            srcPoster() {
                if (this.isJACareerEntrepreApp) {
                    return require('../Images/RapidExperimentingWithJobShadow_new_logo.png');
                }

                return require('../Images/RapidExperimentingWithJobShadow.jpg');
            },
            videoSources() {
                if (this.isJACareerEntrepreApp) {
                    return [
                        {
                            src: 'https://data.ja.org/s/LD0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 1440px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Kz0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 960px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Kj0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 720px)'
                        },
                        {
                            src: 'https://data.ja.org/s/KT0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 480px)'
                        },
                        {
                            src: 'https://data.ja.org/s/KD0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 360px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Jz0AAA',
                            type: 'video/mp4',
                        },

                    ]
                }

                return [{
                    src: 'https://jad4dmedia-usso.streaming.media.azure.net/c4675f27-6996-46e9-bd9b-58df34e59e2d/14_RapidExperimentingWithJobShad.ism/manifest',
                    type: 'application/vnd.ms-sstr+xml'
                }];
            }
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'js_rapid_experiments_with_customers_15', params: {index}})
            }
        },

    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .step-text
    .step
        height 7px
        width 7px
        background-color white
        border-radius 50%
        display inline-block
    .step-text
        background-color color-9
    .cover-body-title-3
        cursor pointer
    .sub-title-initial-3
        font font-sourcesans-regular
        font-size 20px
        color white
        cursor pointer
    .img-preview
        padding-bottom 75% !important
    .btn-secondary
        background-color #f4f6f6
        border none
    .carousel
        display: flex;
        overflow: hidden;
        scroll-behavior: smooth;
        scroll-snap-type: x mandatory;
    .carousel > *
        flex: 1 0 100%;
        scroll-snap-align: start;
    .subtitle
        font font-sourcesans-bold
        font-size 20px
       .byc-container
        background-color color-1
        padding 15px 10px
        min-height 100vh
        max-height 100vh
        overflow hidden

    .skip-link
        padding-right 19px
        font font-poppins-semibold
        font-size 16px
        letter-spacing 0.8px
        color color-5
        cursor pointer

        &:hover
            color color-5

    .title
        padding 0 29px
        font font-poppins-semibold
        letter-spacing 0.53px
        font-size 21px
        color black

    .sub-title
        padding 0 29px
        font font-sourcesans-regular
        font-size 16px
        color color-4

    .content
        background-color white

    .divider
        padding-left 0
        padding-right 0

        &hr
            color black

    .section-title
        font font-poppins-bold
        font-size 16px
        color black
        letter-spacing 0.4px

    .answer-grey
        color color-4

    .sketch-image
        max-width: 98%
        max-height: 60vh

</style>
